import store from '@/store';
import { getAuth, signOut } from '@/amplify/auth';

// import { LOAD_DOMAINS } from '@/store/user/actionTypes';
// import { LOAD_DOMAINS_FROM_CONFIGURATION } from '@/store/project/actionTypes';
import {
  views,
  DEFAULT_LOGGED_IN_ROUTE,
  SP_FREELANCER_REGISTRATION_ROUTE_MAP, SP_COMPANY_REGISTRATION_ROUTE_MAP, DEFAULT_SP_LOGGED_IN_ROUTE,
} from './constants';

export async function publicGuard(to, from, next) {
  const auth = await getAuth();
  // Check if there's an active challenge (MFA setup, password change, etc.)
  const challenge = store.getters.authChallenge;
  const hasActiveChallenge = challenge && challenge.challengeName && challenge.challengeUser;
  if (auth) {
    if (!auth.email_verified) {
      // User has unverified email - allow them to access login page
      // They will see verification modal after completing password login
      if (to.name === views.MODERN_SIGN_IN) {
        next();
      } else if (to.name === views.SIGN_IN_VERIFY_EMAIL) {
        // Old route - redirect to modern sign in
        next({ name: views.MODERN_SIGN_IN });
      } else if (from.name === views.SIGN_IN_VERIFY_EMAIL && to.name === views.SIGN_IN) {
        await signOut();
        next();
      } else {
        // Redirect to login without query parameter
        next({ name: views.MODERN_SIGN_IN });
      }
    } else if (hasActiveChallenge) {
      // User is in a challenge state - redirect to login to show the appropriate modal
      // The ModernSignIn component will handle showing the correct challenge modal
      if (to.name === views.MODERN_SIGN_IN) {
        next();
      } else {
        next({ name: views.MODERN_SIGN_IN });
      }
    } else {
      // Fully authenticated user - redirect to dashboard
      next({ name: DEFAULT_LOGGED_IN_ROUTE });
    }
  } else {
    next();
  }
}

export async function spFreelancerRegistrationGuard(to, from, next) {
  const auth = await getAuth();

  const currentOpenedStepIndex = Number(
    Object.entries(SP_FREELANCER_REGISTRATION_ROUTE_MAP).find(entry => entry[1].name === to.name)?.[0],
  );
  const currentStepIsNotAllowed =
    currentOpenedStepIndex > store.getters.spFreelancerRegistrationVisitedStepsCnt ||
    store.getters.spFreelancerRegistrationCurrentStep === 5;
  if (!auth) {
    if (store.getters.spFreelancerRegistrationCurrentStep !== currentOpenedStepIndex && currentStepIsNotAllowed) {
      next(SP_FREELANCER_REGISTRATION_ROUTE_MAP[store.getters.spFreelancerRegistrationCurrentStep]);
    } else {
      next();
    }
  } else {
    next({ name: DEFAULT_SP_LOGGED_IN_ROUTE });
  }
}

export async function spCompanyRegistrationGuard(to, from, next) {
  const auth = await getAuth();

  const currentOpenedStepIndex = Number(
    Object.entries(SP_COMPANY_REGISTRATION_ROUTE_MAP).find(entry => entry[1].name === to.name)?.[0],
  );
  const currentStepIsNotAllowed =
    currentOpenedStepIndex > store.getters.spCompanyVisitedStepsCnt ||
    store.getters.spCompanyCurrentStep === 5;
  if (!auth) {
    if (store.getters.spCompanyCurrentStep !== currentOpenedStepIndex && currentStepIsNotAllowed) {
      next(SP_COMPANY_REGISTRATION_ROUTE_MAP[store.getters.spCompanyCurrentStep]);
    } else {
      next();
    }
  } else {
    next({ name: DEFAULT_SP_LOGGED_IN_ROUTE });
  }
}

export async function defaultGuard(to, from, next) {
  if (to.meta.allowedForUnauthorizedUsers) {
    next();
  } else {
    const auth = await getAuth();

    if (!auth) {
      next({ name: views.MODERN_SIGN_IN });
    } else if (!auth.email_verified && to.name !== views.SIGN_IN_VERIFY_EMAIL && to.name !== views.MODERN_SIGN_IN && from.name !== views.MODERN_SIGN_IN) {
      // User has unverified email - redirect to login WITHOUT query parameter
      // They will go through normal login flow and see verification modal after password entry
      next({ name: views.MODERN_SIGN_IN });
    } else if ((to.name !== views.NOT_AUTHORIZED) && (to.name !== views.SIGN_OUT) && (to.name !== views.SIGN_IN_VERIFY_EMAIL) && auth['cognito:groups'].includes('TenantUnprivilegedUser')) {
      next({ name: views.NOT_AUTHORIZED });
    } else if (from.name === views.SIGN_IN_MFA_CODE && to.name === views.DASHBOARD &&
      (auth['cognito:groups'].includes('SPAdmin') || auth['cognito:groups'].includes('SPWorker') || auth['cognito:groups'].includes('SPFreelancer'))) {
      next({ name: DEFAULT_SP_LOGGED_IN_ROUTE });
    } else {
      next();
    }
  }
}
